export default "__VITE_ASSET__26068229__"